export const currencyConvertor = (value) =>{
    var formatedValue = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'LKR' }).format(value);
    return formatedValue;
};

export const currencyConvertorNoSymbol = (value) =>{
    var formatedValue = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'LKR'}).format(value);
    return formatedValue.replace("LKR","").trim();
};
